import { render, staticRenderFns } from "./Mng.vue?vue&type=template&id=41dc5004&scoped=true"
import script from "./Mng.vue?vue&type=script&lang=js"
export * from "./Mng.vue?vue&type=script&lang=js"
import style0 from "./Mng.vue?vue&type=style&index=0&id=41dc5004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dc5004",
  null
  
)

export default component.exports